import CONSTANTS from '../../constants';

export function products(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.POS.GET.PRODUCTS:
            return action.products;
        default:
            return state
    }
}